<template>
  <div style="display: flex;justify-content: center;flex-direction: row;height: 100vh;">
    <div style="width: 400px;height: 450px;box-shadow: 0 0 25px #3333331e;padding: 20px 40px;align-self: center;">
      <h2 style="text-align: center;">找回密码</h2>
      <el-form :model="form" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="手机号" prop="pass">
          <el-input type="text" v-model="form.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="form.password_confirm" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机验证码" prop="checkPass">
          <div style="display: flex;flex-direction: row;">
            <el-input type="text" v-model="form.code" autocomplete="off"></el-input>
            <el-button style="margin-left: 20px;" type="info" icon="el-icon-message" circle
                       @click="sendSms"></el-button>
          </div>

        </el-form-item>
        <el-form-item style="padding-top: 30px;">
          <el-button type="primary" @click="submit()">提交</el-button>
          <el-button @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script>
import {SendSmsByForgot} from '../api/login.js'
import {ForgotPassword} from '../api/team.js'
export default {
  name: 'forgot',
  data () {
    return {
      form:{
        phone:''
      }
    }
  },
  mounted () {

  },
  methods:{
    sendSms(){
      if(this.form.phone===''){
        this.$notify({
          message: "手机号错误",
          type: 'warning'
        })
        return
      }
      SendSmsByForgot({phone:this.form.phone}).then(res=>{
        if(res.code===200){
          this.$notify({
            message: '验证码发送成功',
            type: 'success'
          })
        }else{
          this.$notify({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    reset(){
      this.form = {phone:'',password:'',code:'',password_confirm:''}
    },
    submit(){
      if(this.form.phone === '') {
        this.$notify({
          message: "手机号错误",
          type: 'warning'
        })
        return
      }
      if(this.form.code === '') {
        this.$notify({
          message: "请输入验证码",
          type: 'warning'
        })
        return
      }
      if (this.form.password !== this.form.password_confirm){
        this.$notify({
          message: "两次密码不一致",
          type: 'warning'
        })
        return
      }
      ForgotPassword(this.form).then(res=>{
        if(res.code===200){
          this.$notify({
            message: '修改密码成功',
            type: 'success'
          })
        }else{
          this.$notify({
            message: res.message,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Forgot.vue